export abstract class ModalRef<T = unknown> {
  abstract close(result?: T): void;
}